import * as types from "./types";
import _ from "lodash";
export default (state = [], action) => {
  switch (action.type) {
    case types.FETCH_MASTER_CURRENCIES_DDL:
      return { ..._.mapKeys(action.payload, "value") };
    default:
      return state;
  }
};
